import { Paper, Box, Typography } from "@mui/material";
import { styled } from "@mui/material/styles";

export const ListContainer = styled(Paper)(({ theme }) => ({
  width: "100%",
  maxWidth: 1230,
  margin: "16px auto",
  padding: theme.spacing(2),
  boxShadow: theme.shadows[3],
  borderRadius: 12,
}));

export const StyledUserCard = styled("li")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  backgroundColor: "#fff",
  borderRadius: 10,
  padding: theme.spacing(1.5),
  boxShadow: "0 2px 8px rgba(0,0,0,0.05)",
  marginBottom: theme.spacing(1.5),
  listStyle: "none",
  transition: "all 0.2s ease-in-out",
  "&:hover": {
    boxShadow: "0 4px 12px rgba(0,0,0,0.12)",
    transform: "translateY(-2px)",
  },
}));

export const AvatarCircle = styled("div")(({ theme }) => ({
  width: 42,
  height: 42,
  borderRadius: "50%",
  color: "#fff",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  fontWeight: 700,
  marginRight: theme.spacing(2),
  fontSize: 15,
  flexShrink: 0,
}));

export const InfoBox = styled(Box)(() => ({
  display: "flex",
  flexDirection: "column",
  flex: 1,
  overflow: "hidden",
}));

export const StyledNameField = styled(Typography)(() => ({
  fontWeight: 600,
  overflow: "hidden",
  textOverflow: "ellipsis",
  whiteSpace: "nowrap",
  maxWidth: 260,
  textTransform: "uppercase",
  fontSize: 14,
}));

export const StyledTitleField = styled(Typography)(() => ({
  fontWeight: 700,
  color: "#0B3095",
  textTransform: "uppercase",
  fontSize: 14,
}));
export const StyledRoleField = styled(Typography)(() => ({
  fontSize: 13,
  fontWeight: 600,
  color: "#c62828",
}));
